import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL';
import { useParams } from 'react-router-dom';
import MemberIdentityCard from '../Contents/IDCard/MemberIdentityCard';
import '../Contents/IDCard/CardPrintSheet.css';

const PrentablePage = () => {




  const { accesstoken, issuance, Dep_and_post ,ID_ref_Num} = useContext(ContextData);
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token1, token2 } = useParams();



  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @page {
        size: A4;
        margin: 0;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const fetchProfileData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `${baseUrl}/auth/get_member_data_prentable_disc/${token1}/${token2}`,
          {
            withCredentials: true,
            headers: {
              'Accept': 'application/json',
              'authorization': `Bearer ${accesstoken || ''}`
            }
          }
        );

        setProfileData(response.data);

      } catch (err) {
        setError('Error fetching profile data');
      } finally {
        setLoading(false);
      }
    };
    fetchProfileData();
  }, [accesstoken, token1, token2]);

  if (loading) {
    return (
      <div className="prentable-page-con">
        <p>Loading new data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="prentable-page-con">
        <p>{error}</p>
      </div>
    );
  }

  if (!profileData || !Array.isArray(profileData) || profileData.length === 0) {
    return (
      <div className="prentable-page-con">
        <p>No data Page</p>
      </div>
    );
  }

  return (
    <div className="fin-card-print-page">
      <header className="fin-print-toolbar hide-at-prnt"><div><p>FITYANUL ISLAM OF NIGERIA</p><h1>Membership card print sheet</h1><span>{profileData.length} cards · 85.6 × 54 mm · A4 paper</span></div><button onClick={() => window.print()}>Print cards</button></header>
      <p className="fin-print-instructions hide-at-prnt">Check the details below before printing. Choose A4 paper, 100% scale and enable background graphics. Disable browser headers and footers.</p>
      <div className="fin-card-print-sheet">
        {profileData.map((data,index) => <div className="fin-print-card-position" key={data.token || index}><p className="fin-print-slot-label hide-at-prnt">CARD {index + 1} · {data.fname} {data.lname}</p><MemberIdentityCard data={data} stateOfIssue={issuance.state} dateOfIssu={issuance.issuDate} dateOfExpiry={issuance.expiry} ID_ref_Num={data.id_ref_num + "/" + data.r_ID} /></div>)}
      </div>
    </div>
  );
};
export default PrentablePage;
